import type { I18nLocale } from '#/i18n/types/I18nLocale';

export const searchOrgsPathByLocale = {
  en: '/en/organizations',
  es: '/es/organizaciones',
  pt: '/pt/organizacoes',
} satisfies Record<I18nLocale, string>;

export const searchOrgsPaths = Object.values(searchOrgsPathByLocale);

export const searchOrgsPathsWithoutLang = Array.from(
  new Set(searchOrgsPaths.map((path) => path.substring(3))),
);
